import promiseNextTick from './promise-next-tick'

export default function nextTick(fn) {
  promiseNextTick().then(fn)
}
